// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","776":"component---src-pages-contact-form-tsx"}[chunkId] || chunkId) + "-" + {"245":"1623c89bceb11cde92bd","453":"fbbf0a25fbfc35ff1c0f","454":"2a10e51c766dcb0229da","776":"01fdf05d568c849656a7"}[chunkId] + ".js";
};